// extracted by mini-css-extract-plugin
export default {"root":"ToggleButton_root__jza8W","checkbox":"ToggleButton_checkbox__hurnq"};